import { render, staticRenderFns } from "./EvaluationsListView.vue?vue&type=template&id=1342a4d4&scoped=true"
import script from "./EvaluationsListView.vue?vue&type=script&lang=js"
export * from "./EvaluationsListView.vue?vue&type=script&lang=js"
import style0 from "./EvaluationsListView.vue?vue&type=style&index=0&id=1342a4d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1342a4d4",
  null
  
)

export default component.exports